import React from 'react';
import { View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import AppTheme from '../../../AppTheme';
import Carousel from 'react-native-reanimated-carousel';

function CustomCarousel(props) {
    const snapEnabled = true;
    const pagingEnabled = true;
    const viewWidth = props.viewWidth
    const viewHeight = props.viewHeight

    const carouselData = props.carouselData

    const carouselViewBuilder = props.carouselViewBuilder
    const paginationViewBuilder = props.paginationViewBuilder

    const autoPlay = props?.autoPlay ?? true;
    const scallingFactor = props?.scallingFactor ?? 1;
    const scallingFactorOffset = props?.scallingFactorOffset ?? viewWidth
    const autoPlayInterval = props?.autoPlayInterval ?? AppTheme.carouselTransitionDuration;

    const callback = props?.callback

    const progressValue = useSharedValue<number>(0);
    const baseOptions = ({
        vertical: false, width: props.carouelWidth ?? AppTheme.appWidth,
        height: viewHeight,
    } as const);

    return (
        <View style={{ alignItems: 'center' }}>
            <Carousel data={carouselData}
                loop={carouselData.length > 1 ? true : false}
                pagingEnabled={pagingEnabled} snapEnabled={snapEnabled}
                autoPlay={autoPlay} autoPlayInterval={autoPlayInterval}
                onProgressChange={(_, absoluteProgress) =>
                    (progressValue.value = absoluteProgress)
                }
                {...baseOptions}
                mode="parallax" modeConfig={{
                    parallaxScrollingScale: scallingFactor,
                    parallaxScrollingOffset: AppTheme.appWidth - scallingFactorOffset,
                }}
                panGestureHandlerProps={{ activeOffsetX: [-7, 7] }}
                renderItem={({ index }) => carouselViewBuilder(
                    carouselData, index, scallingFactor,
                    viewWidth, viewHeight, callback)} />
            {!!progressValue && carouselData.length > 1 && (
                paginationViewBuilder(carouselData, progressValue)
            )}
        </View>
    );
}


export default CustomCarousel;
